import { createSlice } from "@reduxjs/toolkit";
import lang from "../../assets/lang/icons.json";

const initialState = {
  downloadAppText: [
    {
      Title: "",
      GooglePlay: "",
      AppStore: "",
    },
  ],

  downloadAppColor: [
    {
      downloadAppColor: "rgba(0,0,0,100)",
    },
  ],
  downloadAppSize: [
    {
      downloadAppSize: 1,
    },
  ],
};

export const downloadAppSlice = createSlice({
  name: "downloadApp",
  initialState,
  reducers: {
    downloadAppText: (state, action) => {
      if (Object.values(action.payload).every((el) => el === "")) {
        state.downloadAppText = [];
        state.downloadAppText = [
          ...state.downloadAppText,
          initialState.downloadAppText[0],
        ];
      } else {
        state.downloadAppText = [];
        state.downloadAppText = [...state.downloadAppText, action.payload];
      }
    },

    downloadAppColor: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.downloadAppColor = [];
        state.downloadAppColor = [
          ...state.downloadAppColor,
          initialState.downloadAppColor[0],
        ];
      } else {
        const downloadAppColor = action.payload;

        state.downloadAppColor = [];
        state.downloadAppColor = [
          ...state.downloadAppColor,
          { downloadAppColor },
        ];
      }
    },

    downloadAppSize: (state, action) => {
      if (action.payload === "" && action.payload == null) {
        state.downloadAppSize = [];
        state.downloadAppSize = [
          ...state.downloadAppSize,
          initialState.downloadAppSize[0],
        ];
      } else {
        const downloadAppSize = action.payload;
        state.downloadAppSize = [];
        state.downloadAppSize = [...state.downloadAppSize, { downloadAppSize }];
      }
    },

    resetDownloadApp: (state, action) => {
      if (action.payload === true) {
        state.downloadAppText = [];
        state.downloadAppText = [
          ...state.downloadAppText,
          initialState.downloadAppText[0],
        ];

        state.downloadAppColor = [];
        state.downloadAppColor = [
          ...state.downloadAppColor,
          initialState.downloadAppColor[0],
        ];

        state.downloadAppSize = [];
        state.downloadAppSize = [
          ...state.downloadAppSize,
          initialState.downloadAppSize[0],
        ];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  downloadAppText,
  downloadAppColor,
  downloadAppSize,
  resetDownloadApp,
} = downloadAppSlice.actions;

export default downloadAppSlice.reducer;
